import { TableCell, TableHead, TableRow } from '@mui/material';
import React, { memo } from 'react';

function MeetingsTableHead() {
  return (
    <TableHead>
      <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
        <TableCell sx={{ width: { xs: '200px', sm: '25%' }, minWidth: '150px', fontWeight: 600 }}>
          Title
        </TableCell>
        <TableCell sx={{ width: { xs: '150px', sm: '15%' }, minWidth: '120px', fontWeight: 600 }}>
          Meeting Time
        </TableCell>
        <TableCell sx={{ width: { xs: '100px', sm: '10%' }, minWidth: '80px', fontWeight: 600 }}>
          Duration
        </TableCell>
        <TableCell sx={{ width: { xs: '120px', sm: '12%' }, minWidth: '100px', fontWeight: 600 }}>
          Meeting Status
        </TableCell>
        <TableCell sx={{ width: { xs: '100px', sm: '10%' }, minWidth: '80px', fontWeight: 600 }}>
          Price
        </TableCell>
        <TableCell sx={{ width: { xs: '120px', sm: '12%' }, minWidth: '100px', fontWeight: 600 }}>
          Payment Status
        </TableCell>
        <TableCell sx={{ width: { xs: '150px', sm: '16%' }, minWidth: '120px', pr: 3.5, fontWeight: 600 }} align="right">
          Actions
        </TableCell>
      </TableRow>
    </TableHead>
  );
}

export default memo(MeetingsTableHead);
